import injectScripts from '../utils/inject-scripts'
import isWidgetHalfVisible from '../utils/is-widget-half-visible'
import logger from '../utils/logger'
import { pub, sub, unsub } from '../utils/pub-sub'
import request from '../utils/request'
import widgetPrototypes from './prototypes'

function SysButton({ id, node, container, window, config }) {
  // never change the eternalId!
  // it is used to identify the widget in tracking events - no matter of internal technical changes inside the SDK
  this.eternalId = config.eternalId || 'teaser-button'
  this.type = config.type || 'SysButton'
  this.id = id
  this.node = node
  this.container = container
  this.window = window
  this.config = config
  this.widgetConfiguration = {
    widgetUrl: process.env.SYS_BUTTON_URL,
    ...(window._8select.config.widgets[config.type] || {}),
  }
  this.isActive = false
  this.isDestroyed = false

  sub('app:content:found', this.id, context => {
    if (
      context &&
      (context.widgetType === 'Set' || context.widgetType === 'SetCompose' || context.widgetType === 'SysPsv')
    ) {
      this.activate()
    }
  })
  sub('app:content:notFound', this.id, context => {
    // @todo if there are multiple widgets - this should not be destroyed
    if (
      context &&
      (context.widgetType === 'Set' || context.widgetType === 'SetCompose' || context.widgetType === 'SysPsv')
    ) {
      this.destroy()
    }
  })
  sub('app:error', this.id, context => {
    if (!context || context.widgetId !== id) {
      return
    }
    this.destroy()
  })

  sub('widget:destroy', this.id, context => {
    if (
      context &&
      (context.widgetType === 'Set' || context.widgetType === 'SetCompose' || context.widgetType === 'SysPsv')
    ) {
      // if widget is my target
      this.destroy()
    }
  })

  sub('widget:removedFromDom', this.id, context => {
    if (!context || context.widgetId !== id) {
      return
    }
    this.destroy()
  })

  for (const subscription of this.widgetConfiguration.subscriptions || []) {
    sub(subscription.event, this.id, subscription.callback.bind(this))
  }
}

Object.assign(SysButton.prototype, widgetPrototypes)

SysButton.prototype.load = function(eltxLoadCallback) {
  this.node.style.display = 'none'
  this.node.setAttribute('data-8select-widget-state', 'loading')
  eltxLoadCallback()

  this.handlePreventDefault = function(event) {
    event.preventDefault()
  }
  this.handleWidgetClick = function() {
    // if data-target--blabla => scroll to target
    this.window.eightlytics('clickWidget', {}, undefined, this.getWidgetUuid())
  }.bind(this)
}

SysButton.prototype.activate = function() {
  if (this.isActive === true) {
    return
  }
  this.isActive = true

  const url = this.widgetConfiguration.widgetUrl
  const callback = (error, xhr) => {
    if (error && !xhr) {
      this.destroy()
    }

    this.node.insertAdjacentHTML('afterbegin', xhr.response)
    injectScripts({ node: this.node, html: xhr.response })
    this.node.setAttribute('data-8select-widget-state', 'loaded')
    this.node.style.display = 'block'
    this.addEventListener()
    pub('widget:activate', { widgetId: this.id, widgetType: this.type })
  }

  request(url, 'GET', undefined, callback)
}

SysButton.prototype.addEventListener = function() {
  try {
    const widgetUuid = this.getWidgetUuid()
    const viewWidgetTimeout = () =>
      setTimeout(() => {
        const widgetHasBeenSeen = isWidgetHalfVisible(this)
        if (widgetHasBeenSeen) {
          pub('widget:view', { widgetId: this.id, widgetType: this.type })

          return this.window.eightlytics('viewWidget', {}, undefined, widgetUuid)
        }
        viewWidgetTimeout()
      }, 300)
    viewWidgetTimeout()

    this.node.addEventListener('contextmenu', this.handlePreventDefault)
    this.node.addEventListener('click', this.handleWidgetClick)
    this.node.addEventListener('touchend', this.handleWidgetClick)
  } catch (error) {
    logger('addEventListener failed', { widgetId: this.id, widgetType: this.type, error })
  }
}

SysButton.prototype.destroy = function() {
  if (this.isDestroyed === true) {
    return
  }
  this.isDestroyed = true

  try {
    // avoid to destroy a new widget that is not yet active because some other old compose widget was destroyed
    if (this.isActive !== true) {
      return
    }
    this.isActive = false
    unsub(this.id)

    this.node.innerHTML = ''

    this.node.removeAttribute('data-8select-widget-state')

    this.node.removeEventListener('contextmenu', this.handlePreventDefault)
    this.node.removeEventListener('click', this.handleWidgetClick)
    this.node.removeEventListener('touchend', this.handleWidgetClick)

    this.hide()
    pub('widget:destroy', { widgetId: this.id, widgetType: this.type })
  } catch (error) {
    logger('Error during widget destroy', { widgetConfiguration: this.widgetConfiguration, error })
  }
}

export default SysButton
